import {Injectable} from '@angular/core';
import {SearchWidgetDataItem} from '../../types/SearchWidgetDataItem';
import {ToolsService} from '../tools.service';
import {SearchWidgetData} from '../../types/SearchWidgetData';
import {SearchStateFieldsEnum} from '../../enums/SearchEnums';
import {SearchWidgetUrlBuilderService} from '../search-widget/search-widget-url-builder.service';
import {SearchState} from '../../types/SearchState';
import {SearchWidgetState} from '../../components/search-widget-v2/typings/search-widget-state';

@Injectable({
  providedIn: 'root',
})
export class SearchDataManagerService {
  private findedItemByFieldValue: SearchWidgetDataItem = null;
  private findedParentItemByUrlPath: SearchWidgetDataItem = null;

  constructor(
    private tools: ToolsService,
    private searchWidgetUrlBuilderService: SearchWidgetUrlBuilderService,
  ) {}

  public updateWidgetDataWithRouterLinks(
    data: SearchWidgetData,
    searchState: SearchState,
    widgetState: SearchWidgetState,
  ): SearchWidgetData {
    if (!this.tools.isNil(data)) {
      // we want the search widget to start from a blank state when clicking on a widget item
      searchState = this.tools.clone(searchState);
      searchState.forceSearchResults = false;

      if (!this.tools.isNil(data.popularCaregiverUnitTypes)) {
        data.popularCaregiverUnitTypes.forEach((item) => {
          item.routerLink = this.searchWidgetUrlBuilderService.getSearchResultsRouterLink(
            item,
            SearchStateFieldsEnum.CAREPROVIDER_UNIT_TYPE,
            false,
            true,
            searchState,
            widgetState,
          );
          item.queryParams = this.searchWidgetUrlBuilderService.getSearchResultsQueryParams(
            item,
            SearchStateFieldsEnum.CAREPROVIDER_UNIT_TYPE,
            false,
            true,
            false,
            searchState,
            widgetState,
          );
        });
      }

      if (!this.tools.isNil(data.caregiverUnitTypes)) {
        data.caregiverUnitTypes.forEach((item) => {
          item.routerLink = this.searchWidgetUrlBuilderService.getSearchResultsRouterLink(
            item,
            SearchStateFieldsEnum.CAREPROVIDER_UNIT_TYPE,
            false,
            true,
            searchState,
            widgetState,
          );
          item.queryParams = this.searchWidgetUrlBuilderService.getSearchResultsQueryParams(
            item,
            SearchStateFieldsEnum.CAREPROVIDER_UNIT_TYPE,
            false,
            true,
            false,
            searchState,
            widgetState,
          );
        });
      }

      if (!this.tools.isNil(data.caregiverUnitTypesGrouped)) {
        Object.keys(data.caregiverUnitTypesGrouped).forEach((key) => {
          data.caregiverUnitTypesGrouped[key].forEach((item) => {
            item.routerLink = this.searchWidgetUrlBuilderService.getSearchResultsRouterLink(
              item,
              SearchStateFieldsEnum.CAREPROVIDER_UNIT_TYPE,
              false,
              true,
              searchState,
              widgetState,
            );
            item.queryParams = this.searchWidgetUrlBuilderService.getSearchResultsQueryParams(
              item,
              SearchStateFieldsEnum.CAREPROVIDER_UNIT_TYPE,
              false,
              true,
              false,
              searchState,
              widgetState,
            );
          });
        });
      }

      if (!this.tools.isNil(data.popularCareServiceTypes)) {
        data.popularCareServiceTypes.forEach((item) => {
          item.routerLink = this.searchWidgetUrlBuilderService.getSearchResultsRouterLink(
            item,
            SearchStateFieldsEnum.CARE_SERVICE_TYPE,
            false,
            true,
            searchState,
            widgetState,
          );
          item.queryParams = this.searchWidgetUrlBuilderService.getSearchResultsQueryParams(
            item,
            SearchStateFieldsEnum.CARE_SERVICE_TYPE,
            false,
            true,
            false,
            searchState,
            widgetState,
          );
        });
      }

      if (!this.tools.isNil(data.careServiceTypes)) {
        data.careServiceTypes.forEach((item) => {
          item.routerLink = this.searchWidgetUrlBuilderService.getSearchResultsRouterLink(
            item,
            SearchStateFieldsEnum.CARE_SERVICE_TYPE,
            false,
            true,
            searchState,
            widgetState,
          );
          item.queryParams = this.searchWidgetUrlBuilderService.getSearchResultsQueryParams(
            item,
            SearchStateFieldsEnum.CARE_SERVICE_TYPE,
            false,
            true,
            false,
            searchState,
            widgetState,
          );
        });
      }

      if (!this.tools.isNil(data.careServiceTypesGrouped)) {
        Object.keys(data.careServiceTypesGrouped).forEach((key) => {
          data.careServiceTypesGrouped[key].forEach((item) => {
            item.routerLink = this.searchWidgetUrlBuilderService.getSearchResultsRouterLink(
              item,
              SearchStateFieldsEnum.CARE_SERVICE_TYPE,
              false,
              true,
              searchState,
              widgetState,
            );
            item.queryParams = this.searchWidgetUrlBuilderService.getSearchResultsQueryParams(
              item,
              SearchStateFieldsEnum.CARE_SERVICE_TYPE,
              false,
              true,
              false,
              searchState,
              widgetState,
            );
          });
        });
      }

      if (!this.tools.isNil(data.symptoms)) {
        data.symptoms.forEach((item) => {
          item.routerLink = this.searchWidgetUrlBuilderService.getSearchResultsRouterLink(
            item,
            SearchStateFieldsEnum.SYMPTOM,
            false,
            true,
            searchState,
            widgetState,
          );
          item.queryParams = this.searchWidgetUrlBuilderService.getSearchResultsQueryParams(
            item,
            SearchStateFieldsEnum.SYMPTOM,
            false,
            true,
            false,
            searchState,
            widgetState,
          );
        });
      }

      if (!this.tools.isNil(data.symptomsGrouped)) {
        Object.keys(data.symptomsGrouped).forEach((key) => {
          data.symptomsGrouped[key].forEach((item) => {
            item.routerLink = this.searchWidgetUrlBuilderService.getSearchResultsRouterLink(
              item,
              SearchStateFieldsEnum.SYMPTOM,
              false,
              true,
              searchState,
              widgetState,
            );
            item.queryParams = this.searchWidgetUrlBuilderService.getSearchResultsQueryParams(
              item,
              SearchStateFieldsEnum.SYMPTOM,
              false,
              true,
              false,
              searchState,
              widgetState,
            );
          });
        });
      }
    }
    return data;
  }

  public getWidgetDataItemByFieldValue(
    items: SearchWidgetDataItem[],
    value: string,
    fieldName: string,
  ): SearchWidgetDataItem {
    this.findedItemByFieldValue = null;
    if (!this.tools.isNil(value) && value !== '') {
      this.findWidgetDataItemByFieldValueInChildren(items, value, fieldName, null);
    }
    return this.findedItemByFieldValue;
  }

  public getGroupedWidgetData(widgetData: SearchWidgetData): SearchWidgetData {
    widgetData.caregiverUnitTypesGrouped = this.tools.groupBy(
      widgetData.caregiverUnitTypes.filter((i) => i.area.id > 1),
      'area.name',
    );

    widgetData.careServiceTypesGrouped = this.tools.groupBy(widgetData.careServiceTypes, 'grouping');

    widgetData.symptomsGrouped = this.tools.groupBy(widgetData.symptoms, 'grouping');
    return widgetData;
  }

  private findWidgetDataItemByFieldValueInChildren(
    items: SearchWidgetDataItem[],
    value: string,
    fieldName: string,
    parent: SearchWidgetDataItem,
  ): void {
    if (this.tools.isNil(this.findedItemByFieldValue)) {
      items.forEach((dataItem) => {
        this.markAsFindedOrRunChildrenearch(dataItem, value, fieldName, parent);
      });
    }
  }

  private markAsFindedOrRunChildrenearch(
    dataItem: SearchWidgetDataItem,
    value: string,
    fieldName: string,
    parent: SearchWidgetDataItem,
  ): void {
    if (dataItem[fieldName] === value) {
      this.findedItemByFieldValue = dataItem;
      this.findedParentItemByUrlPath = parent;
    } else if (!this.tools.isNil(dataItem.children) && dataItem.children.length > 0) {
      this.findWidgetDataItemByFieldValueInChildren(dataItem.children, value, fieldName, dataItem);
    }
  }
}
